// extracted by css-extract-rspack-plugin
export default {"ellipsis":"_DFbkp1TfoAaXkWS__ellipsis___","noWrap":"uzWW9iP_sgtdFWHD__noWrap___"};